import { SERVICE_IDS } from '@gasbi/shared';
import { Navigate, useParams } from 'react-router-dom';

import { Pages } from '@/pages';

/**
 * The representative of a ГРМ and the representative and signatory of a підрозділ are BMS employees of the філія (PO,
 * 2026-10-30); their blocks link them as `employees/:employeeId`, which opens the employee's BMS card.
 */
export const BmsEmployeeRedirect = () => {
  const { orgId, employeeId } = useParams<{
    orgId: string;
    employeeId: string;
  }>();

  return (
    <Navigate
      to={`${Pages.ORGANIZATIONS}/${orgId}/${Pages.EMPLOYEES_PART}/services/${SERVICE_IDS.BMS}/${employeeId}`}
      replace
    />
  );
};
